import React from 'react';

function Condicoes() {
  return (
    <>
      <h1>Condições de Empréstimos</h1>
      <p>As operações de empréstimos estão vinculadas à análise de crédito e a disponibilidade  financeira, buscando atender a um maior número de associados.
      </p>
      <ul>
        <li>
          <p className="institucionalText">O associado deverá solicitar seu empréstimo diretamente na Cooperativa. Mediante
            assinatura do contrato e da nota promissória. Todo contrato de empréstimo deverá
            ter um avalista que seja associado da Cooperativa, salvo os casos em que o valor
            solicitado seja até 80% do valor do capital do associado e a critério da diretoria.
          </p>
        </li>
        <li>
          <p className="institucionalText">Limite: O valor do empréstimo será de 04 (quatro) vezes o capital do associado,
            limitado a sua faixa salarial, sendo necessária a aprovação do Conselho de
            Administração. Caso o valor solicitado esteja fora da proporcionalidade das 04 (quatro)
            vezes o capital a complementação (integralização) será realizada somente pela
            liberação do Conselho de Administração, conforme critérios. No caso dos associados
            Aposentados também será concedido empréstimo sem avalista se o valor solicitado
            seja até 80% do capital em casos específicos. Será concedido até 100% do valor do
            capital conforme critério do Conselho de Administração.
          </p>
        </li>
        <li>
          <p className="institucionalText">É permitida a renovação de empréstimo após a liquidação da dívida ou após o
            pagamento da terceira parcela (90 dias).
          </p>
        </li>
        <li>
          <p className="institucionalText">Os contratos poderão ser financiados em até 48 (quarenta e oito), prestações mensais
            e consecutivas. Pagas através de debito bancário (Banrisul e Santander), salvo os casos
            de associados afastados ou autorizados pelo Conselho de Administração, que pagarão
            diretamente no caixa da Cooperativa.
          </p>
        </li>
        <li>
          <p className="institucionalText">Será solicitado ao associado o ultimo contra cheque sempre que haver solicitação de
            empréstimo.
          </p>
        </li>
      </ul>
    </>
  )
}

export default Condicoes;